module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/filetypes/acrobat icon-b0b17b2b.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/filetypes/acrobat icon.svg
// module id = ./app/web/src/assets/filetypes/acrobat icon.svg
// module chunks = 0